import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AllocationService } from 'src/app/services/allocation.service';
@Component({
  selector: 'app-dashboard-assessors',
  templateUrl: './dashboard-assessors.component.html',
  styleUrls: ['./dashboard-assessors.component.css'],
})
export class DashboardAssessorsComponent implements OnInit {
  udata: any;
  counts: any = {};
  constructor(public allocation: AllocationService) { }
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  AllocationList: any;
  ngOnInit(): void {
    this.udata = localStorage.getItem('userdata');
    this.udata = JSON.parse(this.udata);
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      ordering: true,
      searching: true,
      processing: true,
      dom: 'lfrtip',
    };
    this.allocation
      .getAllAllocationByAssessor(this.udata._id)
      .subscribe((item: any) => {
        this.AllocationList = item.result;
        this.counts.assessmentCount = item.result.length;
        this.counts.pending = item.result.filter((item: any) => item.allocationData[0].allocation_status == 'pending' && !item.executive[0]?.status).length;
        this.counts.completed = item.result.filter((item: any) => item.allocationData[0].allocation_status == 'completed').length;
        this.counts.complete = item.result.filter((item: any) => item.executive[0]?.status).length;
        this.dtTrigger.next();
      });
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
